import type { FunctionComponent } from 'react';
import { useCallback } from 'react';
import { useAuth } from 'react-oidc-context';
import { useSelector } from 'react-redux';

import { config } from '../../../config/config';
import { ContextNavigate } from '../../shared/components/context-navigate/context-navigate';
import { Loader } from '../../shared/components/loader/loader';
import { useBalanceChange } from '../../shared/hooks/use-balance-change';
import { useDebounce } from '../../shared/hooks/use-debounce';
import { selectLocale } from '../../shared/store/locale.store';
import {

    useUserAvailableFreeSpinsQuery,
} from '../graphql/query.graphql';

export const FreeSpins: FunctionComponent<unknown> = () => {
    const auth = useAuth();
    const locale = useSelector(selectLocale);
    const userProfileId = auth.user?.profile.user_profile_id as string;

    const [{ fetching }, reload] = useUserAvailableFreeSpinsQuery({
        pause: !userProfileId,
        variables: {
            xTenantId: config.TENANT_ID,
            skinId: config.SKIN_ID,
            userProfileId,
            locale,
        },
        requestPolicy: 'cache-and-network',
    });
    const debounceReload = useDebounce(useCallback(reload, [reload]));

    useBalanceChange(
        useCallback(() => {
            debounceReload();
        }, [debounceReload]),
    );





    if (fetching) {
        return <Loader />;
    }

    return (
        // <FreeSpinsOverview
        //     availableFreeSpins={availableFreeSpins}
        //     inactiveFreeSpins={inactiveFreeSpins}
        // />
        <ContextNavigate to={'/404'} />
    );
};
